import { FormattedMessage } from 'react-intl';

import { Stack, StackProps, Tooltip, Typography } from '@mui/material';

import { AssetType, Offering } from '@arrived/models';

export interface HoldPeriodProps extends StackProps {
  offering: Offering;
}

export const HoldPeriod = ({ offering, ...rest }: HoldPeriodProps) => {
  const { holdPeriodYearsMin, holdPeriodYearsMax } = offering;

  return (
    <Stack direction="row" justifyContent="space-between" py={{ xs: 1.5, md: 2 }} px={{ xs: 0, md: 3 }} {...rest}>
      <Tooltip
        title={
          <FormattedMessage
            id={
              offering.assetType === AssetType.LTR
                ? 'property-details.hold-period.ltr.description'
                : 'property-details.hold-period.str.description'
            }
            values={{ br: <br /> }}
          />
        }
      >
        <Typography sx={{ textDecoration: 'underline' }}>
          <FormattedMessage id="common.hold.period" />
        </Typography>
      </Tooltip>
      <Typography fontWeight="semibold">
        <FormattedMessage id="common.year.range" values={{ range: `${holdPeriodYearsMin}-${holdPeriodYearsMax}` }} />
      </Typography>
    </Stack>
  );
};
